//just a list - latest takings for customer
import * as React from 'react';
import { connect } from 'react-redux';
import RecentTransList from '../../components/recentTransList';
import CalCalDataApi from '../../api/CalCalDataApi';
import { Spinner, View } from 'native-base';
import { deleteTrans } from '../DailyEntries/actions';

//import datas from "./data";
//import { fetchList } from "./actions";
//using dailyEntriesContainer as these are entries, not persisted

class RecentTransContainer extends React.Component {
	componentDidMount() {
		//console.log(this.props.customerId);
		//this.loadRecents(this.props.personId, this.props.personType);
		__DEV__ && console.log('RecentTransContainer, loading for ', this.props.personType, this.props.personId);

		this._unsubscribe = this.props.navigation.addListener('focus', () => {
			this.loadRecents(this.props.personId, this.props.personType);
		});
	}
	constructor(props) {
		super(props);
		//const {nav} = this.props.navigation;
		//const customerId = params.customerId;
		this.initialState = {
			isLoading: true
		};
		this.state = this.initialState;
	}
	componentWillUnmount() {
		!!this._unsubscribe && this._unsubscribe();
	}

	async loadRecents(id, personType) {
		__DEV__ && console.log('loading for ', id);
		var path = personType == 'customer' ? 'dailyEntries/byCustomer/' + id + '/top:25' : 'dailyEntries/bySupplier/' + id + '/top:25';

		CalCalDataApi.dataLoad(path, this.props.jwt, res => {
			this.setState({ isLoading: false });
			this.props.dispatch({
				type: 'PERSON_ENTRIES_LOADED',
				entries: res
			});
		});
	}

	onSelectTrans(item) {
		__DEV__ && console.log('onSelectTrans', item);
		if (item.id < 0) return false;
		if (item.invoice_id) {
			if (item.invoice_status == 'void') return false;
			this.props.navigation.navigate('Invoice', { id: item.id });
		} else {
			this.props.navigation.navigate('Entry', {
				receiptId: this.props.personType == 'customer' ? item.id : null,
				expenseId: this.props.personType == 'supplier' ? item.id : null
			});
		}
	}

	onDeleteTrans(item) {
		this.props.deleteTrans({
			expenseDate: item.expenseDate,
			real_id: item.id,
			transaction_type: this.props.personType == 'customer' ? 'receipt' : 'expense'
		});
	}

	onCopyTrans(item) {
		this.props.navigation.navigate(item.invoice_id ? 'Invoice' : 'Entry', {
			addTrans: this.props.personType == 'customer' ? 'receipt' : 'expense',
			copyId: item.id
		});
	}

	render() {
		//__DEV__ && console.log(this.props.data);
		const { personEntries } = this.props;
		/*if (!this.props.personEntries || this.state.isLoading)
			return (
				<View style={{ alignSelf: 'flex-start', height: 100 }}>
					<Spinner />
				</View>
			);*/
		return (
			<RecentTransList
				list={!this.state.isLoading && personEntries}
				onDeleteTrans={item => this.onDeleteTrans(item)}
				onSelectTrans={item => this.onSelectTrans(item)}
				onCopyTrans={item => this.onCopyTrans(item)}
			/>
		);
	}
}

function bindAction(dispatch) {
	return {
		deleteTrans: item => dispatch(deleteTrans(item)),
		dispatch //the rest!
	};
}

const mapStateToProps = state => ({
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
	personEntries: state.dailyEntriesReducer.personEntries
});
export default connect(mapStateToProps, bindAction)(RecentTransContainer);
